import React, { useLayoutEffect } from 'react';
import { StyleSheet } from 'react-native';
import { AppView, Button, CardView, rem, SCROLL_INDICATOR_INSETS, withAnimatedNavigationHeader } from 'design-system';
import NavigationCloseButton from 'design-system/NavigationCloseButton';
import ScreenInfoHeader from 'design-system/ScreenInfoHeader';
import Text from 'design-system/Text';
import { ProductTransferDisplayMap, ProductTransferDisplayShortMap } from 'features/invest/constants';
import useColors from 'hooks/useColors';
import Animated from 'react-native-reanimated';
import { useMarginBottom } from 'hooks/useMarginBottom';
import { HEIGHT_PLUS_PADDING } from 'design-system/Button';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { isWeb } from '../../../constants';
const strings = {
    title: 'Transfer declaration',
    subTitle: (t) => `Please read what we’ll do to complete your ${t === 'JISA' ? ProductTransferDisplayMap[t] : t} transfer`,
    declaration: (t) => [
        `Contact your current ${ProductTransferDisplayShortMap[t]} provider and instruct them to sell your ${ProductTransferDisplayShortMap[t]} investments and send us the proceeds.`,
        `Hold and manage the transferred funds, including any cash, ${t} investments, interest, dividends, or other proceeds related to your ISA.`,
        `Make any tax-related claims on your behalf that are required for your ${ProductTransferDisplayShortMap[t]}.`,
        `Share and discuss relevant details with your current ${ProductTransferDisplayShortMap[t]} provider to complete the transfer, in line with data protection laws.`,
    ],
    close: 'Close',
};
const ProductTransferDeclarationScreen = withAnimatedNavigationHeader(({ navigation, route, scrollHandler }) => {
    const colors = useColors();
    const { accountType } = route.params;
    const { paddingHorizontalStyle } = useAppFrameDimensions(isWeb);
    const contentContainerStyle = useMarginBottom('paddingBottom', HEIGHT_PLUS_PADDING, paddingHorizontalStyle);
    useLayoutEffect(() => {
        navigation.setOptions({
            headerLeft: () => <NavigationCloseButton inWebHeader onPress={navigation.goBack} colorKey="primary"/>,
            headerTintColor: colors.text.primary,
        });
    }, [colors.text.primary]);
    return (<AppView withFrame={false}>
        <Animated.ScrollView onScroll={scrollHandler} scrollEventThrottle={16} scrollIndicatorInsets={SCROLL_INDICATOR_INSETS} contentContainerStyle={contentContainerStyle}>
          <ScreenInfoHeader title={strings.title} subTitle={strings.subTitle(accountType)}/>
          <CardView noMarginTop noMarginBottom withPadding style={styles.content}>
            {strings.declaration(accountType).map((p, index) => (<Text key={index} TextThin-14 Secondary>
                {p}
              </Text>))}
          </CardView>
        </Animated.ScrollView>
        <Button brand floating title={strings.close} onPress={navigation.goBack}/>
      </AppView>);
}, ({ colors }) => ({
    headerColorOutputRange: [colors.background.dark, colors.cards.onDark],
}));
export default ProductTransferDeclarationScreen;
const styles = StyleSheet.create({
    content: {
        gap: rem(16),
    },
});
